import React from "react";
import styles from "./Loading.module.scss";
interface Props {
  text?: string;
}
const Loading = ({ text }: Props): JSX.Element => (
  <div className={styles.loader} id="koneLoder">
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="logo" className="logo">
        <g id="e" className="letters">
          <rect id="e_rect" className="rect" x="72" y="0" width="22" height="52" />
          <path
            id="e_txt"
            className="txt"
            d="M89.175,6.14 80.334,6.14 80.334,9.171 88.101,9.171 88.099,13.01 80.334,13.01 80.334,16.05 89.175,16.05 89.175,20.119 75.61,20.119 75.61,2.187 89.175,2.187z 	"
          />
        </g>
        <g id="n" className="letters">
          <rect id="n_rect" className="rect" x="48" y="0" width="22" height="52" />
          <path
            id="n_txt"
            className="txt"
            d="M66.476,20.118 64.058,20.118 54.953,11.021 54.953,20.118 50.531,20.118 50.531,2.188 53.267,2.188 62.039,10.944 62.039,2.188 66.476,2.188z 	"
          />
        </g>
        <g id="o" className="letters">
          <rect id="o_rect" className="rect" x="24" y="0" width="22" height="52" />
          <path
            id="o_txt"
            className="txt"
            d="M34.674,1.671c-2.115,0-4.061,0.641-5.619,1.781c-2.237,1.637-3.678,4.302-3.678,7.575 c0,3.271,1.439,5.938,3.675,7.577c1.559,1.143,3.505,1.786,5.622,1.786c2.044,0,3.93-0.6,5.461-1.67 c2.329-1.628,3.838-4.344,3.838-7.693c0-3.349-1.508-6.062-3.837-7.688C38.605,2.27,36.719,1.671,34.674,1.671z M34.673,16.158 c-2.547,0-4.516-2.088-4.516-5.131c0-3.036,1.968-5.131,4.516-5.131c2.541,0,4.516,2.095,4.516,5.131 C39.189,14.07,37.214,16.158,34.673,16.158z"
          />
        </g>
        <g id="k" className="letters">
          <rect id="k_rect" className="rect" x="0" y="0" width="22" height="52" />
          <path
            id="k_txt"
            className="txt"
            d="M14.045,20.118 7.899,11.623 7.899,20.118 3.118,20.118 3.118,2.188 7.899,2.188 7.899,10.011 13.817,2.188 19.448,2.188 12.913,10.628 19.896,20.118z 	"
          />
        </g>
      </g>
      <filter id="blur1">
        <feGaussianBlur in="SourceGraphic" stdDeviation="0 3" />
      </filter>
      <filter id="blur2">
        <feGaussianBlur in="SourceGraphic" stdDeviation="0 0" />
      </filter>
    </svg>
    <h1>{text}</h1>
  </div>
);

export default Loading;
